import * as React from 'react';

export interface DragDropProps {
  dragActive?: boolean;
}

interface DragDropState {
  dragActive?: boolean;
}

export const withDragDrop = (Wrapped: React.ComponentClass<any>) => {
  return class DragDropContainer extends React.Component<any, DragDropState> {
    private wrappedComponent: any;
    public state: Readonly<DragDropState> = {
      dragActive: false
    };

    private onDragLeave = (e: any) => {
      e.preventDefault();
      this.setState({
        dragActive: false
      });
    };

    private onDragOver = (e: any) => {
      e.preventDefault();
      try {
        // This throws on IE...
        e.dataTransfer.dropEffect = 'copy';
      }
      // eslint-disable-next-line no-empty
      catch { }

      this.setState({
        dragActive: true
      });
    };

    private onDrop = (e: any) => {
      e.preventDefault();

      let files;
      if (e.dataTransfer) {
        files = e.dataTransfer.files;
      } else if (e.target) {
        files = e.target.files;
      }

      if (this.wrappedComponent && this.wrappedComponent.handleUpload) {
        this.wrappedComponent.handleUpload(files);
      }

      this.setState({
        dragActive: false
      });
    };

    private setRef() {
      return (c) => this.wrappedComponent = c;
    }

    public render() {
      return (
        <div
          id={this.props.componentId}
          onDragOver={this.onDragOver}
          onDragLeave={this.onDragLeave}
          onDrop={this.onDrop}
          className="col-12">
          <Wrapped
            ref={this.setRef()}
            {...this.props}
            dragActive={this.state.dragActive} />
        </div>
      );
    }
  };
};
